export default __webpack_public_path__ + "static/media/arrowDown.d5a97573.svg";